<<template>
  <div class="detail-panel">
    <div class="btn-panel">
        <a v-if="this.action != 'View'" class="btn btn-default" @click="save">{{$rs["btn_save"]}}</a>
      <slot></slot>
    </div>
    <hr>
    <div class="row">
        <div class="input-group col-md-3">
          <span class="input-group-addon" >{{rs["companyNo"]}}</span>
          <select class="form-control" v-model="data.companyNo">
            <option v-for="(item, idx) in config.company" :value='item.value'>{{item.text}}</option>
          </select>
        </div>
    </div>
    <div class="row">
      <div v-show='action=="View" || action=="Edit"'  class="input-group col-md-3" >
        <span class="input-group-addon" >{{rs["leaveId"]}}</span>
        <input type="text" class="form-control" readonly v-model="data.leaveId">
      </div>
      <div class="input-group col-md-3" >
        <span class="input-group-addon" >{{rs["leaveType"]}}</span>
        <select  class="form-control" v-model="data.leaveType">
          <option v-for="item in qjType" :value='item.lbdm'>{{item.qjlb}}</option>
        </select>
      </div>
    </div>
    <div class="row" >
      <div class="input-group col-md-6" >
        <span class="input-group-addon" >{{rs["reason"]}}</span>
        <textarea v-bind:readonly='action=="View"' v-model="data.reason"
          rows="2" cols="30" type="text" class="form-control" />
      </div>
    </div>
    <div class="row" style="display:none" >
      <div class="input-group col-md-6" >
        <span class="input-group-addon" >{{rs["remark"]}}</span>
        <textarea v-bind:readonly='action=="View"' v-model="data.remark"
          rows="2" cols="30" type="text" class="form-control" />
      </div>
    </div>
      <hr>


    <div class="row" style="margin-left:15px">
      <div class="col-md-3">
        <div v-if='action!="View"' class="input-group" style="margin-left:0">
          <span class="input-group-addon">员工</span>
          <input ref="gnNo" v-model="gnNo" @keyup.enter="onEnter" type="text" class="form-control">
          <div class="input-group-btn">
            <button @click.stop="onEnter" class="btn btn-default">添加</button>
            <button @click.stop="clear" class="btn btn-default">清除全部</button>
          </div>
        </div>
        <select size="10" class="col-md-12" style="height: 300px;">
          <option v-for="(item, idx) in gnList" :value="item.empId" @dblclick.stop="removeItem(idx)">{{item.empId}}  {{item.empName}}</option>
        </select>
      </div>

      <div class="col-md-6">
        <div v-if='action!="View"' class="btn-group" role="group" style="margin-top: 5px; margin-bottom: 5px;">
            <button @click.stop="addItem" class="btn btn-default">添加请假时间</button>
            <button @click.stop="clearItem" class="btn btn-default">清除全部请假时间</button>
        </div>
        <div size="10" class="col-md-12 " style="height: 350px; overflow: auto;">
          <div class="row">
            <table class="col-md-12 fui-table">
              <thead>
                <tr>
                  <th style="width: 25px;">编辑</th>
                  <th style="width: 25px;">删除</th>
                  <th style="width: 50px;">开始日期</th>
                  <th style="width: 50px;">结束日期</th>
                  <th style="width: 50px;">{{rs["beginTime"]}}</th>
                  <th style="width: 50px;">{{rs["endTime"]}}</th>
                  <th style="width: 50px;">{{rs["leaveTime"]}}</th>
                  <th style="width: 50px;">{{rs["dayOrNight"]}}</th>
                </tr>
              </thead>
              <tbody id="qjTimeList">
                <tr v-for="(item, idx) in times">
                  <td><a @click.stop="editItem(item, idx)">编辑</a></td>
                  <td><a @click.stop="delItem(idx)">删除</a></td>
                  <td>{{formatter.fdate(item.beginDate)}}</td>
                  <td>{{formatter.fdate(item.endDate)}}</td>
                  <td>{{formatter.ftime(item.beginTime)}}</td>
                  <td>{{formatter.ftime(item.endTime)}}</td>
                  <td>{{formatter.ftime(item.leaveTime)}}</td>
                  <td>{{formatDN(item.dayOrNight)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <times v-if="showAdd" :rs="rs" :itime="editDetail" @close="close" :times="times" :idx="idx" />
  </div>
</template>

<<script>
import times from "./addTime";
export default {
  props:["action", "detailData", "rs", "qjType","url", "config"],
  created: function() {
    if(this.action=="Add" || this.action == "Copy") this.data.lbdm = 20
    //console.log(this.gnList)
    if (!this.gnList) this.gnList = []
    if (!this.times) this.times = []
  },
  data(){
    return {
      data: this.$extend({}, this.detailData),
      showAdd: 0, 
      gnNo: null, 
      gnList: this.config.users,
      times: this.config.times,
      editDetail: null,
      idx: -1
    }
  },
  methods: {
    close: function() {
      this.showAdd = 0
    },
    getBegin(item, p){
      if (item[p+"bt"]==0) return "上班时间"
      else if (item[p+"bt"]==1) return this.formatN(item[p+"bth"]) + ":" + this.formatN(item[p+"btm"])
    },
    getEnd(item, p){
      if (item[p+"et"]==0) return "下班时间"
      else if (item[p+"et"]==1) return this.formatN(item[p+"eth"]) + ":" + this.formatN(item[p+"etm"])
    },
    formatN(n){
      if (n<10) return "0" + n
      else return n 
    },
    formatDN(n){
      if (n) return this.rs["dayOrNight" + n]
      else return this.rs["dayOrNight1"]
    },
    editItem(item, idx){
      this.editDetail = item
      this.showAdd = 1
      this.idx = idx
    },
    delItem(idx){
        this.times.splice(idx,1)
    },
    addItem(){
      this.editDetail = { }
      this.showAdd = 1
      this.idx= -1
    },
    clearItem(){
      this.editItem = null 
      this.times = []
    },
    save:function(){
      if (!this.gnList || this.gnList.length<=0) {
        this.alertRS("userNull")
        return
      }
      if (!this.times || this.times.length<=0) {
        this.alertRS("timesNull")
        return 
      }
      this.data.typeName = this.qjType.find(d=>{return d.lbdm==this.data.leaveType}).qjlb
      this.data.companyName = this.config.company.find(d=>{return d.value==this.data.companyNo}).text

      const dt ={
        main: this.data,
        users: this.gnList,
        times: this.times
      }

      if (this.action == "Add" || this.action == "Copy") {
        dt.main.autoid=0
        this.$save(this.url + "Save", dt, this.saveResult);          
      } else if (this.action == "Edit") {
        this.$save(this.url + "Save", dt, this.saveResult);
      }
    },
    saveResult(rs){
      if (rs.rs==1) {
        if (this.action == "Add" || this.action == "Copy") {
          this.$parent.$data.isNeedReload=true
          this.data.autoid=rs.autoid
          this.data.qjid=rs.qjid
          this.action = "Edit"
        }
        else{
          this.$parent.$data.isNeedReload=true
        }

        if (this.confirmRS("msg_save_success_back")) this.$emit("back");
      }
      else if (rs && rs.rs == -1) this.alertRS("existed")
    },
    onEnter(){
      if (this.$trim(this.gnNo)=="") {
        this.$refs.gnNo.select()
        return
      }

      const dt = this.gnList.filter(d=>{
        return d.empId==this.gnNo || d.empName==this.gnNo
      })
      if (dt.length>0) {
        this.$refs.gnNo.select()
        return
      } 
      this.$getData(this.url+"GetUser?No=" + this.gnNo, data=>{
        if (data.rs==1){
          this.gnList.push(data.emp)
          this.gnNo=""
        }
        else{
          this.$alert(this.rs["notFound"])
          this.$refs.gnNo.select()
        }
      })
    },
    removeItem(idx){
        this.gnList.splice(idx,1)
    },
    clear(){
      this.gnList = []
      this.$refs.gnNo.select()
    },
  },
  components: { times }
}
</script>

